<template>
  <v-dialog :model-value="isOpen" opacity = "0.5" persistent>
    <template #default>
      <div class="d-flex justify-center mt-6">
        <v-card
          :width="mobile ? '90%' : '65%'"
          max-height="78vh"
          color="white"
          elevation="3"
          class="d-flex flex-column"
        >
          <v-toolbar flat density="compact" color="white">
            <div class="d-flex align-center">
              <v-btn icon color="primary" @click="close()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            
            <v-chip variant="tonal" color="primary" v-if="productModel.productId">
              ID: {{ productModel.productId }}
            </v-chip>
    
            <v-spacer />
    
            <v-btn @click="deleteProduct()" icon color="primary">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-toolbar>

          <v-form ref="form" class=" card-scroll">
            <v-row dense class="pa-8 flex-grow-1">
              <v-col cols="12">
                <v-sheet >
                   <div class="d-flex align-center mb-4">
                    <v-icon color="primary" class="mr-2" size="small">mdi-sprout</v-icon>
                    <span class="text-subtitle-1 text-primary" style="color: #1F4529;">Identificação</span>
                  </div>
                </v-sheet>
                <v-divider class="mb-4"></v-divider>
              </v-col>
              <v-col cols="12" md="6" sm="8">
                <div>
                  <v-text-field
                    v-model="productModel.productName"
                    label="Produto"
                    variant="outlined"
                    rounded
                    color="primary"
                    density="compact"
                    :rules="[v => !!v || 'Campo obrigatório']"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="8" sm="10">
                <div>
                  <v-text-field
                    v-model="productModel.productDesc"
                    label="Descrição"
                    variant="outlined"
                    rounded
                    color="primary"
                    density="compact"
                  />
                </div>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12">
                <v-sheet >
                   <div class="d-flex align-center mb-4">
                    <v-icon color="primary" class="mr-2" size="default">mdi-seed-plus</v-icon>
                    <span class="text-subtitle-1 text-primary" style="color: #1F4529;">Informações adicionais</span>
                  </div>
                </v-sheet>
                <v-divider class="mb-4"></v-divider>
              </v-col>
              <v-col cols="12" md="4" sm="5">
                <div>
                  <v-text-field
                    v-model="productModel.productSize"
                    label="Tamanho"
                    variant="outlined"
                    rounded
                    density="compact"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6" sm="7">
                  <v-autocomplete
                    v-model="productModel.productCategory"
                    :items="category.lstCategory"
                    :item-title="item => `${item.categoryId} - ${item.categoryName}`"
                    item-value="categoryId"
                    rounded
                    variant="outlined"
                    density="compact"
                    label="Categoria"
                    :rules="[v => !!v || 'Campo obrigatório']"
                  ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" sm="7">
                  <v-autocomplete
                    v-model="productModel.productPot"
                    :items="pot.lstPot"
                    :item-title="item => `${item.potId} - ${item.potName}`"
                    item-value="potId"
                    rounded
                    variant="outlined"
                    density="compact"
                    label="Pote"
                    :rules="[v => !!v || 'Campo obrigatório']"
                  ></v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions class="mt-n6 pb-6 pr-6">
            <div class="d-flex flex-column flex-md-row w-100 justify-end">
              <v-btn
                rounded
                variant="flat"
                @click="close()"
              >
                Cancelar
              </v-btn>
              <v-btn
                rounded
                color="primary"
                class="ml-2"
                variant="elevated"
                @click="save()"
              >
                Salvar
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </div>
    </template>
  </v-dialog>
</template>


<script>
import { useDisplay } from 'vuetify'

export default {
  setup () {
    const { mobile } = useDisplay()
    return { mobile }
  },
  data: () => ({
    productId: ''
  }),
  computed: {
    product: {
      get() {
        return this.$store.state.product
      }
    },
    productModel: {
      get() {
          return this.$store.state.product.product
      },
    },
    isOpen: {
      get() {
        return Boolean(this.$route.params.productId || this.$route.name == 'NewProduct')
      },
      set(value) {
        if (!value) {
          this.$router.push({ name: 'ProductGrid' })
        }
      }
    },
    category: {
        get() {
            return this.$store.state.category
        }
    },
    pot: {
        get() {
            return this.$store.state.pot
        }
    }
  },
  methods: {
    async save() {
      const { valid } = await this.$refs.form.validate()
      if (!valid) return
      
      const success = await this.$store.dispatch("product/save")
      if (success) {
        this.$store.commit('product/setShouldReload', true)
        this.close()
      }
    },
    close() {
      this.$router.push({ name: 'ProductGrid' })
    },
    async deleteProduct() {
      const confirmed = await this.$store.dispatch('systemDialogOptions/confirm', null, { root: true })
      if (!confirmed) 
          return false
        
      const success = await this.$store.dispatch("product/delete")
      if (success) {
        this.$store.commit('product/setShouldReload', true)
        this.close()
      }
    }
  },
  watch: {
    '$route.params.productId': {
      immediate: true,
      async handler(id) {
        if(id) {
          await this.$store.dispatch('product/find', id)
        } else {
          this.$store.commit('product/initForm')
        }
      }
    }
  }
}
</script>


<style>

.card-scroll {
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
}
</style>